import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { ProductItemGroup } from "@domain/project/floorplan/product-item-group";
import { nextGroupId } from "@domain/project/group-id.utils";
import { NavigationService } from "@domain/project/navigation.service";
import { ButtonComponent } from "@odx/angular/components/button";
import { IconComponent } from "@odx/angular/components/icon";
import { CreatedGroupMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/created-group-menu/created-group-menu.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";

@Component({
  selector: "app-floorplan-group-menu",
  standalone: true,
  imports: [CreatedGroupMenuComponent, ButtonComponent, IconComponent],
  templateUrl: "./group-menu.component.html",
  styleUrl: "./group-menu.component.scss",
})
export class GroupMenuComponent {
  protected floorplanService = inject(FloorplanService);
  private navigationService = inject(NavigationService);
  private router = inject(Router);

  isGroupSelected(id: string) {
    return this.floorplanService.selectedFloorplan.floorplanState.isGroupSelected(id);
  }

  get currentFloorplanGroups() {
    return this.floorplanService.selectedFloorplan.project.groups;
  }

  onClick() {
    const floorplan = this.floorplanService.selectedFloorplan;
    const groupId = nextGroupId(floorplan.project.groups);
    const groupName = $localize`:@@floorplan.details.form.group.defaultName:Gruppe ${groupId}`;

    const newGroup = new ProductItemGroup(groupName, groupId, [floorplan.id]);
    floorplan.project.addGroup(newGroup);

    const url = this.router.url;
    this.navigationService.toGroupConfiguration(floorplan.id, newGroup.id, url);
  }
}
